<template>
    <div>
        <pc-label
            v-bind:label="label"
            for-id="SummationValueHiddenInput"
            v-bind:show-help="showHelp"
            v-bind:help-link="showHelpLinkOnly"
            v-on:help-clicked="emitHelpClicked" />
        <div>
            <slot name="help" />
        </div>
        <div data-test-role="summation-result">
            {{ display }}
        </div>
        <input
            id="SummationValueHiddenInput"
            v-model="value"
            data-test-role="summation-hidden"
            type="hidden" />
    </div>
</template>

<script>
    import base from "./_elementBase";

    export default {
        extends: base,
        computed: {
            display() {
                const numVal = Number(this.value) || 0;

                let precision = this.getNumericPropertyValue("precision");
                if (precision === null) {
                    precision = 2;
                } // allow for precision of "0"

                let strVal = numVal.toFixed(precision);
                if (this.dataFormatter) {
                    strVal = this.dataFormatter.format(strVal);
                }

                const prefix = this.getBooleanPropertyValue("prefix");
                const unit = this.element.Properties.units || "";
                return `${prefix ? unit : ""}${strVal}${!prefix ? " " + unit : ""}`;
            }
        }
    };
</script>
